import {FileData} from "../models/common/FileData";
import {compare} from "./Sort";
import {MapByStr} from "../models/common/Map";

/**
 * converts a base64 encoded string into an byte array
 * @param base64 encoded string
 */
export function base64ToArrayBuffer( base64: string ): Uint8Array {

    let binaryString = window.atob( base64 );

    let binaryLen = binaryString.length;
    let bytes = new Uint8Array( binaryLen );

    for( let i = 0; i < binaryLen; i++ ) {

        let ascii = binaryString.charCodeAt( i );
        bytes[ i ] = ascii;

    }
    return bytes;
}


export function downloadFileHelper( file: string, fileData: FileData ) {
    //console.log( file );

    const byteArray = base64ToArrayBuffer( file );

    //@ts-ignore
    const blob = new Blob( [ byteArray ] , { type: fileData.mime } )

    let link = document.createElement('a');

    link.href = window.URL.createObjectURL( blob );
    link.download = fileData.originalName;

    link.style.display = "none";

    document.body.appendChild( link );

    link.click();

    document.body.removeChild( link );

    return blob;
}

/**
 * sorts given file data
 * @param fileData
 */
export function sortFileDataByType( fileData: FileData[] ): FileData[] {

    return fileData.sort( (a, b) => compare( a.mime, b.mime ) );

}

/**
 * creates a map with key string from FileData::mime
 *
 * @param fileData { FileData[] }
 * @return MapByStr< FileData[]>
 */
export function fileDataToFileTypeMap( fileData: FileData[] ): MapByStr<FileData[]> {
    let filesBYType: { [ key: string ]: FileData[] } = {};



    fileData.forEach( _file  => {

        if( filesBYType.hasOwnProperty( _file.mime ) ) {
            filesBYType = {
                ...filesBYType,
                [ _file.mime ]: [ ...filesBYType[ _file.mime ], _file ]
            };
        } else {
            filesBYType = {
                ...filesBYType,
                [ _file.mime ]: [ _file ]
            };
        }
    });

    return filesBYType;

}